import { inject, Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { GetApplicantList, VerifyDocsAction } from './verify-docs.actions';
import { ProExamService } from '@tsin-core/services/http/pro-exam.service';
import { LoadingState } from '@tsin-core/entities';
import { catchError, tap } from 'rxjs';

export class VerifyDocsStateModel {
  public applicantList: any[] = [];
  public loading!: LoadingState;

}

const defaults = {
  applicantList: [],
  loading: LoadingState.notLoading,
};

@State<VerifyDocsStateModel>({
  name: 'verifyDocsState',
  defaults
})
@Injectable()
export class VerifyDocsState {

  proExamService: ProExamService = inject(ProExamService);

  @Selector()
  static getApplicantList(state: VerifyDocsStateModel) {
    return state.applicantList;
  }

  @Selector()
  static getLoading(state: VerifyDocsStateModel) {
    return state.loading;
  }

  @Action(GetApplicantList)
  getApplicantList(ctx: StateContext<VerifyDocsStateModel>, action: GetApplicantList) {
    ctx.patchState({ loading: LoadingState.loadingList });
    return this.proExamService.getApplicantList(action.payload).pipe(
      tap((result: any) => {
        const state = ctx.getState();
        ctx.patchState({
          applicantList: result,
          loading: LoadingState.notLoading
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }

}
